/**
 * Copyright (c) 2019, Trend Micro, Inc.
 * All rights reserved.
 */
const API_VERSION = 'v1';
const devUrl =
  process.env.DEPLOYMENT_TARGET === 'alpha' || process.env.DEPLOYMENT_TARGET === 'dev'
    ? `/trend-us-1`
    : '';

export const isSessionValid = async () => {
  const url = `${devUrl}/api/sessions/current`;
  try {
    let rID = '';
    if (typeof window !== 'undefined') {
      rID = window.sessionStorage.getItem('rID');
    }
    let response = await fetch(url, {
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
        'api-version': API_VERSION,
        updateLastActivity: false,
        rID,
      },
    });

    if (response.ok) {
      // if HTTP-status is 200-299
      // get the response body (the method explained below)
      const json = await readApiJson(response);
      // console.log('TCL: isSessionValid -> json', json);
      // console.log('session is valid: ', json.RID === rID);
      return json.RID === rID;
    } else {
      // e.g. if HTTP-status is 401
      // console.log('session is invalid');
      if (typeof window !== 'undefined') {
        window.sessionStorage.removeItem('rID');
      }
      return false;
    }
  } catch (error) {
    console.error(`API request to "${url}" failed`, error);
  }
};

export const logoutSession = async () => {
  // [C1WS-670] Need to use /rest/session API instead of newer version /api/sessions/current to avoid
  // WS AWS ELB routing issue where session will not get invalidated immediately on the UI node
  // Note that once regional base WS is available, this will no longer be an issue with both API endpoint
  const url = `${devUrl}/rest/session`;
  const CLEAR_SESSION = `${process.env.APP_PREFIX}CLEAR_SESSION`;
  try {
    const response = await fetch(url, {
      method: 'DELETE',
      cache: 'no-store',
      headers: {
        'api-version': API_VERSION,
      },
    });

    if (response.status === 204) {
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(CLEAR_SESSION, Date.now());
        window.localStorage.removeItem(CLEAR_SESSION);
        window.c1c_clearCurrentSession();
      }
      return response.status;
    } else {
      // e.g. if HTTP-status is 401
      // console.log('session is invalid');
      window.localStorage.setItem(CLEAR_SESSION, Date.now());
      window.localStorage.removeItem(CLEAR_SESSION);
      window.c1c_clearCurrentSession();
      return false;
    }
  } catch (error) {
    console.error(`API request to "${url}" failed`, error);
  }
};

const readApiJson = async (response) => {
  const contentType = response.headers.get('content-type');
  if (!contentType || contentType.indexOf('application/json') === -1) {
    throw new Error(`Invalid response content-type: ${contentType}`);
  }

  let contentLength = response.headers.get('Content-Length');
  try {
    contentLength = parseInt(contentLength);
  } catch (e) {
    // best effort, header may not have been sent by server
  }

  let json;
  try {
    if (contentLength === 0) {
      json = await Promise.resolve({});
    } else {
      json = await response.json();
    }
  } catch (e) {
    throw new Error(`Api returned invalid json body: \n\t${err}`);
  }
  if (json.error) {
    throw new Error(`Api returned error: ${json.error}`);
  } else {
    return json;
  }
};
